import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-column">
            <h3 className="footer-title">HORARIOS</h3>
            <div className="footer-content">
              <p>VALENCIA: <small>DE LUNES A DOMINGO 12:00PM A 10:00PM</small></p>
              <p>MARACAY: <small>DE LUNES A DOMINGO 12:00PM A 10:00PM</small></p>
              <p>CARACAS-CATIA: <small>DE LUNES A DOMINGO 12:00PM A 10:00PM</small></p>
              <p>CARACAS-LA FLORIDA: <small>DE LUNES A DOMINGO 12:00PM A 10:00PM</small></p>
              <p>BARQUISIMETO: <small>DE LUNES A DOMINGO 12:00PM A 10:00PM</small></p>
            </div>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">DIRECCIÓN</h3>
            <div className="footer-content">
              <p>VALENCIA: <small>C.C BRISAS DEL VALLE, NIVEL TERRAZAS, REMANSO, SAN DIEGO, VALENCIA</small></p>
              <p>MARACAY: <small>C.C LAS AMERICAS, NIVEL FERIA, AV LAS DELICIAS, MARACAY</small></p>
              <p>CARACAS-CATIA: <small>2DA AVENIDA, CRUCE CON CALLE ECUADOR, CATIA, CARACAS</small></p>
              <p>CARACAS-LA FLORIDA: <small>AV. LOS JARDINES, DIAGONAL A RESIDENCIAS FLORIDA SUITES, LA FLORIDA, CARACAS</small></p>
              <p>BARQUISIMETO: <small>CC SAMBIL, NIVEL TERRAZAS, BARQUISIMETO</small></p>
            </div>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">CONTÁCTANOS</h3>
            <div className="footer-content">
              <p>WHATSAPP: <small>0412-6274276</small></p>
              <p>E-MAIL: <small>CONTACTO@CHEFMARGARO.COM</small></p>
              <p>NÚMERO TELEFÓNICO: <small>0412-6274276</small></p>
              <div className="footer-social">
                <a href="https://www.instagram.com/chefmargaro/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                </a>
                <a href="https://www.tiktok.com/@chefmargaro?lang=en" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="social-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                  </svg>
                </a>
                <a href="https://www.facebook.com/profile.php?id=100092081379704" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">SECCIONES</h3>
            <div className="footer-content">
              <Link to="/" className="footer-link">INICIO</Link>
              <Link to="/categorias" className="footer-link">CATEGORÍAS</Link>
              <Link to="/combos" className="footer-link">COMBOS</Link>
              <Link to="/nosotros" className="footer-link">NOSOTROS</Link>
              <Link to="/contactanos" className="footer-link">CONTÁCTANOS</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

